<style lang="scss">
  @import '../resources/scss/id_current_projects.scss';
</style>

<script lang="ts">
  import type ProjectsSection from '../api/rest/directus-cms/investigation/models/ProjectsSection'
  import MoreInfoLinkBtn from './MoreInfoLinkBtn.svelte'

  export let section: ProjectsSection
</script>

{#if section}
  <div class="container-fluid py-section bg-secondary-n">
    <div class="container-xxl flex-grow-1">
      <div class="row">
        <div class="col-12 col-lg-7">
          <h1 class="text-primary-red mb-4">{section.title}</h1>
          {#if section.projects && section.projects[0] && section.projects[0]?.description}
            <div class="h4 mb-0">
              {@html section.projects[0]?.description}
            </div>
          {/if}
        </div>
        <div class="col-12 col-lg-5">
          {#if section.projects[0]?.images}
            <div
              class="d-flex justify-content-center align-items-start gap-4 icon-container flex-wrap"
            >
              {#each section.projects[0]?.images as img}
                <img class="mw-100" src={img.image?.fullUrl} alt={img.description} />
              {/each}
            </div>
          {/if}
        </div>
        <div class="col-12 col-md-6 pt-4">
          <MoreInfoLinkBtn
            link={section.projects[0]?.button_link === ''
              ? section.projects[0]?.file?.fullUrl
              : section.projects[0]?.button_link}
            name={section.projects[0]?.button_name === ''
              ? section.title
              : section.projects[0]?.button_name}
            btnClass="red me-0 me-lg-4"
          />
        </div>
      </div>
    </div>
  </div>
{/if}
